import AddDashboard from "./add-dashboard";
import AddWidget from "./add-widget";

export default function() {
    const rootModule = "tfApp.dashboard.oms.dialog";
    return angular.module(rootModule, [AddDashboard(rootModule), AddWidget()])
                  .name;
}
